<template>
  <span class="id-display" :class="{ 'id-truncated': isTruncated }" :title="fullId">
    {{ displayValue }}
    <el-tooltip v-if="isTruncated" placement="top">
      <div slot="content">
        <div>完整ID: {{ id }}</div>
        <div v-if="isTruncated" class="id-warning">
          此ID超出JavaScript安全整数范围，显示时可能会有精度丢失
        </div>
      </div>
      <i class="el-icon-warning-outline" style="margin-left: 4px; color: #E6A23C;"></i>
    </el-tooltip>
  </span>
</template>

<script>
import { isIdSafe, formatId } from '@/utils/id-utils';

export default {
  name: 'IdDisplay',
  props: {
    // The ID to display
    id: {
      type: [String, Number],
      required: true
    },
    // Maximum length before truncating
    maxLength: {
      type: Number,
      default: 12
    },
    // Whether to show the warning icon for large IDs
    showWarning: {
      type: Boolean,
      default: true
    },
    // Whether to truncate long IDs
    truncate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // Format the ID to ensure it's a string
    fullId() {
      return formatId(this.id) || '';
    },
    
    // Check if the ID is safely representable as a JavaScript number
    isSafe() {
      return isIdSafe(this.id);
    },
    
    // Whether the ID should be truncated in display
    isTruncated() {
      return this.truncate && 
             this.fullId.length > this.maxLength && 
             !this.isSafe && 
             this.showWarning;
    },
    
    // The value to actually display
    displayValue() {
      if (!this.truncate || this.fullId.length <= this.maxLength) {
        return this.fullId;
      }
      
      // Truncate in the middle for very long IDs
      const start = Math.ceil(this.maxLength / 2);
      const end = this.fullId.length - Math.floor(this.maxLength / 2);
      
      return this.fullId.substring(0, start) + '...' + this.fullId.substring(end);
    }
  }
};
</script>

<style scoped>
.id-display {
  font-family: monospace;
  white-space: nowrap;
}

.id-truncated {
  cursor: help;
}

.id-warning {
  color: #E6A23C;
  margin-top: 5px;
  font-size: 12px;
}
</style> 


// WEBPACK FOOTER //
// src/components/common/IdDisplay.vue